<app-bread-crumb></app-bread-crumb>

<app-announcement-info [FunctionID]="this.quarterlyres.FunctionID"></app-announcement-info>
